<template>
  <div class="avatar" :style="{ background: color }">{{ initials }}</div>
</template>

<script>
const AVATAR_COLORS = [
  '#E85D5D', '#E8955D', '#D4C44A', '#5DA65D', '#5D9AE8',
  '#7B5DE8', '#E85DAD', '#5DC4C4', '#C45DE8', '#E87B5D',
];

export default {
  name: 'EmployeeAvatar',

  props: {
    emp: {
      type: Object,
      required: true,
    },
  },

  computed: {
    initials() {
      // Real API fields: surname + christian_name1
      // Fallback chain: employee-level → user-level → empty string
      const surname       = this.emp.surname        || (this.emp.user && this.emp.user.surname)        || '';
      const christianName = this.emp.christian_name1 || (this.emp.user && this.emp.user.christian_name1) || '';
      const s = surname.charAt(0);
      const c = christianName.charAt(0);
      return (s + c).toUpperCase() || '?';
    },
    color() {
      return AVATAR_COLORS[(this.emp.id || 0) % AVATAR_COLORS.length];
    },
  },
};
</script>

<style scoped>
.avatar {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #fff;
  font-size: 12px;
  flex-shrink: 0;
  user-select: none;
}
</style>